import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { SeriesCard } from "./SeriesCard";
// import ConsolidatedSummary from "./ConsolidatedSummary"; // Removed
import { Package, Calendar, Clock } from "lucide-react";
import { decodeSeries, mapEtapaToGradeName, cn, getSeriesBatchItems } from "@/lib/utils";
import { formatDate } from "@/lib/formatters";
import { getSecondSemesterAdjustmentDeadline } from "@/lib/orderCycle";
interface OrderItem {
    id: number;
    codigo_produto: string;
    descricao_produto: string;
    preco: number;
    ano_letivo: number;
    marca: string;
    sku: string;
    status: string;
    utilizacao?: string | null;
    serie?: string | null;
    segmento?: string | null;
    quantidade_contratual: number;
    desconto: number;
    quantidade_pedido: number;
    valor_liquido: number;
    valor_total: number;
    delivery_type_id: number;
    delivery_type_number: number;
    brand_id: number;
    is_optional?: boolean;
}
interface ProductTableProps {
    orderItems: OrderItem[];
    fullOrderItems: OrderItem[]; // New prop
    updateQuantidade: (index: number, quantidade: number) => void;
    updateQuantidadesBatch: (updates: Array<{ id: number; quantidade: number }>) => void; // New prop
    formatCurrency: (value: number) => string;
    clientHasOrders?: boolean;
    getDisplayQuantity?: (item: OrderItem) => number;
    shippingFee?: number;
    isScheduled: boolean; // Added isScheduled
    isSimulated?: boolean; // Added isSimulated
    cycleYear?: number;
}
const ProductTableScheduled = ({
    orderItems,
    fullOrderItems, // Destructure new prop
    updateQuantidade,
    updateQuantidadesBatch, // New prop
    formatCurrency,
    clientHasOrders = false,
    getDisplayQuantity,
    isScheduled, // Destructure isScheduled
    isSimulated = false, // Destructure isSimulated
    cycleYear = 2026,
}: ProductTableProps) => {
    const [openSeries, setOpenSeries] = useState<Record<string, boolean>>({});

    const getImmediateProducts = () => {
        if (isScheduled) return [];
        return orderItems
            .sort((a, b) => {
                const labelA = decodeSeries(Number(a.serie));
                const labelB = decodeSeries(Number(b.serie));
                return labelA.localeCompare(labelB, undefined, { numeric: true, sensitivity: 'base' });
            });
    };

    const getScheduledProducts = () => {
        if (!isScheduled) return [];
        return orderItems
            .sort((a, b) => {
                const labelA = decodeSeries(Number(a.serie));
                const labelB = decodeSeries(Number(b.serie));
                return labelA.localeCompare(labelB, undefined, { numeric: true, sensitivity: 'base' });
            });
    };

    const alunoItems = orderItems.filter(i => i.utilizacao?.toLowerCase() === "aluno");
    const professorItems = orderItems.filter(i => i.utilizacao?.toLowerCase() === "professor");
    const toggleSeries = (serie: string) => {
        setOpenSeries(prev => ({
            ...prev,
            [serie]: !prev[serie]
        }));
    };
    const groupItemsBySeries = (items: OrderItem[]) => {
        const grouped: Record<string, OrderItem[]> = {};
        // Map marca string to brand_id number
        const getBrandId = (marca: string): number => {
            const brandIdMap: Record<string, number> = {
                "1": 1,
                "2": 2,
                "3": 3,
                "4": 4,
                "5": 5,
            };
            return brandIdMap[marca] || 0;
        };

        items.forEach((item) => {
            const serie = mapEtapaToGradeName(item.serie);
            if (!grouped[serie]) {
                grouped[serie] = [];
            }
            grouped[serie].push(item);
        });

        // Apply the same sorting logic used in useOrderCalculations
        Object.keys(grouped).forEach((serie) => {
            grouped[serie] = grouped[serie].sort((a, b) => {
                // First, sort by brand_id (map from marca field)
                const brandIdA = getBrandId(a.marca);
                const brandIdB = getBrandId(b.marca);
                if (brandIdA !== brandIdB) {
                    return brandIdA - brandIdB;
                }

                // Special handling for Plataforma AZ products to be sequential
                const aPlatform = a.descricao_produto.includes("Plataforma AZ");
                const bPlatform = b.descricao_produto.includes("Plataforma AZ");

                if (aPlatform && bPlatform) {
                    const aFirst = a.descricao_produto.includes("1º Semestre");
                    const bFirst = b.descricao_produto.includes("1º Semestre");
                    if (aFirst && !bFirst) return -1;
                    if (!aFirst && bFirst) return 1;
                }

                // No other sorting needed - products are sorted by brand_id only
                return 0;
            });
        });

        return grouped;
    };
    // const groupItemsBySeries = ( items: OrderItem[] ) => {
    //     const grouped: Record<string, OrderItem[]> = {};
    //     items.forEach( item => {
    //         const serie = item.serie || 'Sem Série';
    //         if ( !grouped[ serie ] ) {
    //             grouped[ serie ] = [];
    //         }
    //         grouped[ serie ].push( item );
    //     } );

    //     // Apply the same sorting logic used in useOrderCalculations
    //     Object.keys( grouped ).forEach( serie => {
    //         grouped[ serie ] = grouped[ serie ].sort( ( a, b ) => {
    //             // First, sort by brand_id
    //             if ( a.brand_id !== b.brand_id ) {
    //                 return a.brand_id - b.brand_id;
    //             }

    //             // Special handling for Plataforma AZ products to be sequential
    //             const aPlatform = a.descricao_produto.includes( "Plataforma AZ" );
    //             const bPlatform = b.descricao_produto.includes( "Plataforma AZ" );

    //             if ( aPlatform && bPlatform ) {
    //                 const aFirst = a.descricao_produto.includes( "1º Semestre" );
    //                 const bFirst = b.descricao_produto.includes( "1º Semestre" );
    //                 if ( aFirst && !bFirst ) return -1;
    //                 if ( !aFirst && bFirst ) return 1;
    //             }

    //             // Then by utilização (Aluno first, then Professor)
    //             if ( a.utilizacao !== b.utilizacao ) {
    //                 const aIsTeacher = a.utilizacao === "Professor" ? 1 : 0;
    //                 const bIsTeacher = b.utilizacao === "Professor" ? 1 : 0;
    //                 return aIsTeacher - bIsTeacher;
    //             }

    //             // Finally by product description alphabetically
    //             return a.descricao_produto.localeCompare( b.descricao_produto );
    //         } );
    //     } );

    //     return grouped;
    // };

    const handleUpdateQuantity = (
        itemId: number,
        quantity: number,
        updateAllInSeries?: boolean
    ) => {
        const originalIndex = orderItems.findIndex((item) => item.id === itemId);
        if (originalIndex !== -1) {
            if (updateAllInSeries) {
                const targetItem = orderItems[originalIndex];
                const targetSerie = targetItem.serie;
                const targetUtilizacao = targetItem.utilizacao;

                const updates = getSeriesBatchItems(
                    orderItems.filter(
                        (item) =>
                            item.serie === targetSerie && item.utilizacao === targetUtilizacao
                    )
                ).map((item) => ({ id: item.id, quantidade: quantity }));

                updateQuantidadesBatch(updates);
            } else {
                updateQuantidade(originalIndex, quantity);
            }
        }
    };

    const renderCardsSection = (items: OrderItem[], sectionType: string, isScheduledArea: boolean = false) => {
        const groupedItems = groupItemsBySeries(items);
        return <div className="space-y-4">
            {Object.entries(groupedItems).map(([serie, serieItems]) => {
                const uniqueKey = `${sectionType}-${serie}`;
                return (
                    <SeriesCard
                        key={uniqueKey}
                        serie={serie}
                        items={serieItems}
                        isOpen={openSeries[uniqueKey] || false}
                        onToggle={() => toggleSeries(uniqueKey)}
                        onUpdateQuantity={handleUpdateQuantity}
                        formatCurrency={formatCurrency}
                        clientHasOrders={clientHasOrders}
                        isScheduledArea={isScheduledArea}
                        getDisplayQuantity={getDisplayQuantity}
                        cycleYear={cycleYear}
                    />
                );
            })}
        </div>;
    };

    // Renderizar seção de itens imediatos (Aluno + Professor)
    const renderImmediateSection = (items: OrderItem[]) => {
        const alunoItems = items.filter(i => i.utilizacao?.toLowerCase() === "aluno");

        return (
            <div className="space-y-6">
                {alunoItems.length > 0 && (
                    <div>
                        <h4 className="text-md font-semibold mb-3 flex items-center gap-2">
                            <span className="text-[35px]">🎒</span> Materiais para Aluno
                        </h4>
                        {renderCardsSection(alunoItems, "aluno", false)}
                    </div>
                )}
            </div>
        );
    };

    // Renderizar seção de itens programados
    const renderScheduledSection = (items: OrderItem[]) => {
        const alunoItems = items.filter(i => i.utilizacao?.toLowerCase() === "aluno");

        return (
            <div className="space-y-6">
                {alunoItems.length > 0 && (
                    <div>
                        <h4 className={cn(
                            "text-md font-semibold mb-3 flex items-center gap-2",
                            isSimulated ? "text-indigo-700" : "text-purple-700"
                        )}>
                            <span className="text-[35px]">🎒</span> {isSimulated ? "Materiais para Aluno" : "Materiais para Aluno - 2º Semestre"}
                        </h4>
                        {renderCardsSection(alunoItems, "aluno-scheduled", true)}
                    </div>
                )}
            </div>
        );
    };

    const renderSection = (title: string, items: OrderItem[], emptyIcon: string, emptyMessage: string, sectionType: string) => <Card className="mb-8 shadow-sm border">
        <CardHeader className="pb-4">
            <CardTitle className="text-xl font-semibold text-foreground flex items-center gap-2">
                <span className="text-2xl">{emptyIcon}</span>
                {title}
                {items.length > 0}
            </CardTitle>
        </CardHeader>
        <CardContent className="pt-0 space-y-6">
            {items.length === 0 ? <div className="rounded-lg border border-dashed border-muted-foreground/30 p-12 text-center">
                <div className="text-6xl mb-4">{emptyIcon}</div>
                <p className="text-muted-foreground text-lg">{emptyMessage}</p>
            </div> : renderCardsSection(items, sectionType)}
        </CardContent>
    </Card>;

    // Interface separada para clientes com pedidos
    if (clientHasOrders) {
        const immediateItems = getImmediateProducts();
        const scheduledItems = getScheduledProducts();

        return (
            <div className="space-y-6">
                {/* ÁREA 1: PEDIDOS IMEDIATOS - Azul */}
                {immediateItems.length > 0 && (
                    <Card className="border-2 border-blue-300">
                        <CardHeader className="bg-blue-50 border-b border-blue-200">
                            <CardTitle className="text-lg flex items-center gap-2">
                                <Package className="h-5 w-5 text-blue-600" />
                                Pedido
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="pt-6">
                            {renderImmediateSection(immediateItems)}
                        </CardContent>
                    </Card>
                )}

                {/* ÁREA 2: PEDIDOS PROGRAMADOS OU SIMULADOS */}
                {scheduledItems.length > 0 && (
                    <Card className={cn(
                        "border-2 transition-all",
                        isSimulated
                            ? "border-indigo-400 bg-indigo-50/20"
                            : "border-purple-400 bg-purple-50/20"
                    )}>
                        <CardHeader className={cn(
                            "border-b",
                            isSimulated ? "bg-indigo-100 border-indigo-200" : "bg-purple-100 border-purple-200"
                        )}>
                            <div className="flex items-center justify-between flex-wrap gap-4">
                                <div>
                                    <CardTitle className="text-lg flex items-center gap-2">
                                        {isSimulated ? (
                                            <Package className="h-5 w-5 text-indigo-600" />
                                        ) : (
                                            <Calendar className="h-5 w-5 text-purple-600" />
                                        )}
                                        {isSimulated ? "Pedido Simulado (ENEM/Avaliações)" : "Pedidos Programados - 2º Semestre"}
                                    </CardTitle>
                                    {!isSimulated && (
                                        <p className="text-sm text-purple-600 mt-1">
                                            Ajuste a quantidade até {formatDate(getSecondSemesterAdjustmentDeadline(cycleYear))}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </CardHeader>
                        <CardContent className="pt-6">
                            {renderScheduledSection(scheduledItems)}
                        </CardContent>
                    </Card>
                )}

            </div>
        );
    }

    // Interface original para clientes sem pedidos
    return <div className="space-y-6">
        {renderSection("Materiais para Aluno", alunoItems, "🎒", "Nada por aqui! Nenhum material para Aluno no momento.", "aluno")}
    </div>;
};
export default ProductTableScheduled;